import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { StudentDeactivationService } from './student-deactivate.service'
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

declare let customToastr: any;

@Component({
  selector: 'app-student-deactivate',
  templateUrl: './student-deactivate.component.html',
  styleUrls: ['./student-deactivate.component.css'],
  providers: [StudentDeactivationService]
})
export class StudentDeactivateComponent implements OnInit {

  @Input() studentName: string;
  @Input() visible: string;
  @Input() studentId: string;
  @Input() studentSelectedAcademicYear : string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  deactivateReasons;
  selectedReason;
  isDeactivateProcessing = false;
  isDataLoading = false;

  constructor(private studentDeactivationService: StudentDeactivationService, private translate: TranslateService) { }

  ngOnInit() {
    this.selectedReason = null;
    this.deactivateReasons = [];
    this.isDeactivateProcessing = false;
    this.isDataLoading = false;
    this.getDeactivationReasonList();
  }

  getDeactivationReasonList() {
    this.isDataLoading = true;
    this.studentDeactivationService.getDeactivateReasonList()
      .subscribe(
        (data: any) => {
          this.isDataLoading = false;
          this.deactivateReasons = data;
        },
        error => {
          this.isDataLoading = false;
        }
      );
  }

  async popupOkAction() {
    if (this.selectedReason && this.selectedReason != 'null') {
      this.isDeactivateProcessing = true;
      this.studentDeactivationService.deactivateStudent(this.studentId, this.selectedReason,this.studentSelectedAcademicYear)
        .subscribe(
          async (data: any) => {
            if (data.status) {
              const studentSuccessfullyDeactivatedTranslation = await firstValueFrom(this.translate.get('studentSuccessfullyDeactivated')); 
              customToastr(studentSuccessfullyDeactivatedTranslation, 'success');
              this.isDeactivateProcessing = false;
              this.save_button_event.emit();
            }
            else {
              this.isDeactivateProcessing = false;
              const failedToDeactivateStudentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeactivateStudentPleaseTryAgain')); 
              customToastr(failedToDeactivateStudentPleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            this.isDeactivateProcessing = false;
            const failedToDeactivateStudentPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeactivateStudentPleaseTryAgain')); 
            customToastr(failedToDeactivateStudentPleaseTryAgainTranslation, 'error');
          }
        );
    }
    else {
      const pleaseSelectReasonForDeactivationTranslation = await firstValueFrom(this.translate.get('pleaseSelectReasonForDeactivation')); 
      customToastr(pleaseSelectReasonForDeactivationTranslation, 'error');
    }
  }

  close() {
    this.visible = 'none';
    this.closePopup.emit();
  }
}
